/* eslint-disable */
import React from 'react';
import ReactModal from 'react-modal';
import { RegularButton } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';
import { ConfirmButtonsContainer, TabTitle, TabTitle1 } from './styles';

const ConfirmEmptyModal: React.FC<{
  isOpen: boolean;
  setConfirmEmptySubmit: (b: boolean) => void;
}> = ({ isOpen, setConfirmEmptySubmit }) => {
  const { t } = useTranslation();

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          margin: 'auto',
          width: '600px',
          maxWidth: '900px',
          height: '400px',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '20px',
        },
      }}
    >
      <TabTitle1>
        <b>{t('benefits.signModal.QLETitle')}</b>
      </TabTitle1>
      <TabTitle />
      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', textAlign: 'center' }}>
        <p style={{ fontWeight: 'bolder' }}>{t('benefits.qualifyingLifeEvent.invalidQle')}</p>
        <p>{t('benefits.qualifyingLifeEvent.invalidQleAlert')}</p>
      </div>
      <ConfirmButtonsContainer>
        <RegularButton
          onClick={() => {
            setConfirmEmptySubmit(false);
          }}
          style={{ minWidth: '80%', background: 'white', color: 'blue' }}
        >
          {t('global.form.ok')}
        </RegularButton>
      </ConfirmButtonsContainer>
    </ReactModal>
  );
};

export default ConfirmEmptyModal;
